module.exports = __webpack_public_path__ + "img/jbisumari_thumbnail_img@2x.cca0620a.png";